import React from 'react'
import { IIconProps } from './interface/IIconProps'

/** Icone de colpsar o painel a esquerda */
export const LeftPanelCloseIcon: React.FC<IIconProps> = ({
  color,
  height,
  width
}) => {

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width || "16"}
      height={height || "16"}
      viewBox="0 0 16 16"
    >
      <path
        fill={color || "#22638D"}
        d="M132-828.444v-7.111L128.444-832zM121.778-824a1.712 1.712 0 01-1.256-.522 1.712 1.712 0 01-.522-1.256v-12.444a1.712 1.712 0 01.522-1.255 1.712 1.712 0 011.256-.522h12.444a1.712 1.712 0 011.256.522 1.712 1.712 0 01.522 1.255v12.444a1.712 1.712 0 01-.522 1.256 1.712 1.712 0 01-1.256.522zm4.444-1.778h8v-12.444h-8z"
        transform="translate(-120 840)"
      ></path>
    </svg>
  )
}
 